/**
 * converters.js
 * Talkroute
 *
 * Created by Vel Genov on 1/25/18
 * Copyright (c) 2019 Talkroute. All right reserved.
 */

/**
 * Format a passed in seconds string in the following format
 * MM:SS seconds/minutes
 * @param {*} secondsString the string to format
 */
export function formatSeconds(secondsString: string) {
  const totalSeconds = parseInt(secondsString, 10);

  const seconds = totalSeconds % 60;
  const minutes = Math.floor(totalSeconds / 60) % 60;

  const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;

  return `${minutes}:${formattedSeconds}`;
}

export function formatSecondsWithQualifier(secondsString: string) {
  const totalSeconds = parseInt(secondsString, 10);
  const humanDuration =
    totalSeconds >= 3600
      ? new Date(totalSeconds * 1000).toISOString().substr(11, 8)
      : new Date(totalSeconds * 1000).toISOString().substr(14, 5);
  return humanDuration;
}
